<style lang="css">

</style>

<template lang="html">

<div>

    <el-table :data="datas" style="width: 100%">
        <el-table-column prop="taskName" label="收支类型">
        </el-table-column>
        <el-table-column prop="carCoin" label="金额（汽车币）">
          <template scope="scope">
            <span>{{scope.row.taskName==="提现兑换消耗"?"-":"+"}}{{scope.row.carCoin}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间">
            <template scope="scope">
                <span>{{scope.row.create_time | dateTimeFormat}}</span>
            </template>
        </el-table-column>
    </el-table>
    <el-pagination style="margin-top:10px;" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
    </el-pagination>

</div>

</template>

<script>

import coinModel from '@/framework/models/coinModel'
export default {
  name: 'user-coin-detail',
  data: function () {
    return {
      id: null,
      pageNum: 1,
      pageSize: 10,
      datas: [],
      total: 0
    }
  },
  created: function () {
    let params = this.$route.params
    this.id = params.id
    this.loadList()
  },
  methods: {
    handleCurrentChange: function (pageNum) {
      this.pageNum = pageNum
      this.loadList()
    },
    handleSizeChange: function (pageSize) {
      this.pageSize = pageSize
      this.pageNum = 1
      this.loadList()
    },
    loadList: function () {
      let _this = this
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        lcwUserInfoId: this.id
      }
      let listener = {
        success: function (dataInfo) {
          _this.datas = dataInfo.data
          _this.total = dataInfo.recordsTotal
        }
      }

      coinModel.findCarCoinRecordsByLcwUserId(_this, params, listener)
    }
  }
}

</script>
